import React__default from 'react';

const tableCaption = "_table-caption_d9c7o_1";
const styles = {
	tableCaption: tableCaption
};

const TableCaption = ({ children, show = false }) => {
  return React__default.createElement("caption", { className: styles.tableCaption, "data-show": show ? true : void 0, "data-zds": true }, children);
};

export { TableCaption };
//# sourceMappingURL=TableCaption.es.js.map
